module.exports = __webpack_public_path__ + "static/empty-states-buttons-dont-3f41e6ed22c6b2cd1597548b2b7a4561.png";